"use client";

import Link from "next/link";
import AreaCodeBlogLink from "@/components/AreaCodeBlogLink";
import CurrentTime from "@/components/CurrentTime";
import type { AreaCode } from "@/types/areaCode";

type AreaCodeRowProps = {
  areaCode: AreaCode;
  showRegionCell?: boolean;
  regionRowSpan?: number;
};

export default function AreaCodeRow({ areaCode, showRegionCell = false, regionRowSpan }: AreaCodeRowProps) {
  return (
    <tr className="border-b border-line align-top">
      {showRegionCell ? (
        <th className="directory-cell font-semibold text-ink" data-label="State / Province / Territory" rowSpan={regionRowSpan} scope="rowgroup">
          <Link className="text-harbor hover:underline" href={`/area-codes/${areaCode.regionSlug}`}>
            {areaCode.region}
          </Link>
        </th>
      ) : null}
      <td className="directory-cell font-bold" data-label="Area Code">
        <AreaCodeBlogLink code={areaCode.code} />
      </td>
      <td className="directory-cell" data-label="Location">
        <Link className="font-semibold text-ink hover:text-harbor hover:underline" href={`/area-codes/${areaCode.regionSlug}`}>
          {areaCode.region}
        </Link>
        <span className="text-slate-700">: {areaCode.cities.slice(0, 4).join(", ")}</span>
      </td>
      <td className="directory-cell whitespace-nowrap text-slate-800" data-label="Current Time">
        <CurrentTime timezoneIds={areaCode.timezoneIds} timezoneLabels={areaCode.timezoneLabels} />
      </td>
    </tr>
  );
}
